import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import {
  ActionIcon,
  Badge,
  Button,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  TextInput,
  Anchor,
  Modal,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import { Eye, Search } from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import {
  deleteAgreementBulk,
  getAgreementAuditLog,
} from "../../utilities/apis/agreements";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementsList,
  getAgreementTypesApi,
  getAgreementsCsvDownload,
} from "../../utilities/apis/agreements";

import Styles from "./AgreementsListingPage.module.css";

const AgreementAuditLogModal = ({ agreementId }) => {
  const [auditLogData, setAuditLogData] = useState(null);

  console.log("agreementId", agreementId);
  console.log("type", typeof agreementId);

  useEffect(() => {
    if (!agreementId) return;

    const fetchAuditLog = async () => {
      try {
        const response = await apiWrapWithErrorWithData(
          getAgreementAuditLog({ agreementId }),
        );

        if (response.success) {
          setAuditLogData(response.auditLogs);
        }
      } catch (error) {
        console.error("Error fetching audit log:", error);
      }
    };

    fetchAuditLog();
  }, [agreementId]);

  const formatAuditDate = (value) => {
    if (!value) return "-";

    // dd/MM/yyyy At HH:mm
    const match = value.match(
      /^(\d{2})\/(\d{2})\/(\d{4})\s+(?:At|at|AT)\s+(\d{2}):(\d{2})$/,
    );

    if (match) {
      const [, day, month, year, hour, minute] = match;

      const date = new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
      );

      return date.toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return value;
    }

    return date.toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <>
      <div
        className="flex items-center justify-between mb-6 pb-4"
        style={{
          borderBottom: "1px solid #edf2f7",
        }}
      >
        <div>
          <Text fw={700} size="xl">
            Agreement Audit Log
          </Text>

          <Text c="dimmed" size="sm">
            Agreement #{agreementId}
          </Text>
        </div>

        <Badge size="xl" radius="xl" variant="light" color="blue">
          {auditLogData?.length || 0}
        </Badge>
      </div>

      {auditLogData === null && (
        <div className="flex flex-col gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height={45} radius="md" />
          ))}
        </div>
      )}

      {auditLogData?.length === 0 && (
        <div
          className="flex justify-center items-center"
          style={{ minHeight: 220 }}
        >
          <Text c="dimmed">No audit history found.</Text>
        </div>
      )}

      {auditLogData?.length > 0 && (
        <div className="flex flex-col">
          <Table
            striped
            highlightOnHover
            withBorder
            verticalSpacing="lg"
            horizontalSpacing="xl"
            sx={{
              borderRadius: 12,
              overflow: "hidden",
            }}
          >
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Last Action User</th>
                <th>Role</th>
                <th>Pending With</th>
                <th>Time Stamp</th>
              </tr>
            </thead>
            <tbody>
              {auditLogData
                .slice()
                .reverse()
                .map((log, index) => (
                  <tr key={log.id || index}>
                    <td>
                      <Badge radius="xl" size="lg" color="cyan" variant="light">
                        {index + 1}
                      </Badge>
                    </td>

                    <td>
                      <Text fw={500}>{log.lastActionUser || "-"}</Text>
                    </td>

                    <td>
                      <Badge color="indigo" variant="light">
                        {log.lastActionUserRole || "-"}
                      </Badge>
                    </td>

                    <td>
                      <Badge color="grape" variant="dot">
                        {log.pendingWith || "-"}
                      </Badge>
                    </td>

                    <td>
                      <Text size="sm" fw={500} c="dimmed">
                        {formatAuditDate(log.timeStamp)}
                      </Text>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default AgreementAuditLogModal;
